export default {"src":"/_next/static/media/chevronLeft_16.d6e7e15e.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};